module.exports = __webpack_public_path__ + "img/OpenSans-LightItalic.9f8dbef1.svg";